<script setup>
import { usePushNotificationStore } from "@/store/pushNotificationStore";
import { computed, onMounted } from "vue";

const pushNotificationStore = usePushNotificationStore();
const toggleNotifications = () => {
    pushNotificationStore.toggleNotifications();
};

const isNotificationsEnabled = computed(() => {
    return pushNotificationStore.getNotificationsState();
});

onMounted(() => {
  pushNotificationStore.getNotificationsState();
});
</script>

<template>
  <button v-if="!$store.state.user.roles.includes('ROLE_ADMIN')" class="bell-button" @click="toggleNotifications">
    <svg
      v-if="isNotificationsEnabled"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_658_4395)">
        <path
          d="M23.2584 16.2002L20.6584 6.82917C20.1032 4.82459 18.8935 3.06331 17.2217 1.82566C15.5499 0.588005 13.5122 -0.0549039 11.4329 -0.000744217C9.35356 0.0534155 7.35208 0.801531 5.74701 2.12454C4.14194 3.44754 3.02552 5.26941 2.57543 7.30017L0.564427 16.3502C0.46712 16.7886 0.469493 17.2433 0.571373 17.6807C0.673252 18.1181 0.872037 18.5271 1.15306 18.8774C1.43409 19.2277 1.79018 19.5105 2.19507 19.7048C2.59996 19.8991 3.04332 20.0001 3.49243 20.0002H7.09943C7.32894 21.1305 7.94216 22.1466 8.83517 22.8766C9.72818 23.6065 10.8461 24.0052 11.9994 24.0052C13.1528 24.0052 14.2707 23.6065 15.1637 22.8766C16.0567 22.1466 16.6699 21.1305 16.8994 20.0002H20.3694C20.8315 20 21.2873 19.893 21.7013 19.6876C22.1153 19.4823 22.4762 19.184 22.7559 18.8162C23.0357 18.4484 23.2267 18.0209 23.314 17.5672C23.4013 17.1134 23.3827 16.6455 23.2594 16.2002H23.2584ZM11.9994 22.0002C11.3812 21.9976 10.7788 21.8041 10.2747 21.4461C9.77066 21.0881 9.38951 20.5831 9.18343 20.0002H14.8154C14.6093 20.5831 14.2282 21.0881 13.7241 21.4461C13.2201 21.8041 12.6177 21.9976 11.9994 22.0002ZM21.1644 18.1052C21.0711 18.2289 20.9501 18.329 20.8112 18.3976C20.6723 18.4662 20.5193 18.5013 20.3644 18.5002H3.49243C3.3427 18.5001 3.19487 18.4665 3.05988 18.4017C2.92489 18.3369 2.80617 18.2426 2.71249 18.1258C2.61881 18.009 2.55255 17.8726 2.51862 17.7268C2.48469 17.5809 2.48394 17.4293 2.51643 17.2832L4.52743 8.23317C4.88179 6.63938 5.75874 5.20978 7.01889 4.17162C8.27904 3.13347 9.85006 2.54634 11.4822 2.50359C13.1144 2.46083 14.714 2.96489 16.0268 3.93564C17.3395 4.90639 18.2901 6.28812 18.7274 7.86117L21.3274 17.2322C21.3699 17.3804 21.3773 17.5364 21.349 17.6879C21.3207 17.8394 21.2574 17.9823 21.1644 18.1052Z"
          fill="#00BF53"
        />
      </g>
      <defs>
        <clipPath id="clip0_658_4395">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_658_4389)">
        <path
          d="M23.2589 16.2002L20.6589 6.82917C20.1037 4.82459 18.8939 3.06331 17.2221 1.82566C15.5504 0.588005 13.5127 -0.0549039 11.4333 -0.000744217C9.35398 0.0534155 7.35251 0.801531 5.74744 2.12454C4.14237 3.44754 3.02594 5.26941 2.57585 7.30017L0.564854 16.3502C0.467547 16.7886 0.469921 17.2433 0.5718 17.6807C0.673679 18.1181 0.872464 18.5271 1.15349 18.8774C1.43451 19.2277 1.79061 19.5105 2.1955 19.7048C2.60039 19.8991 3.04374 20.0001 3.49285 20.0002H7.09985C7.32937 21.1305 7.94258 22.1466 8.8356 22.8766C9.72861 23.6065 10.8465 24.0052 11.9999 24.0052C13.1532 24.0052 14.2711 23.6065 15.1641 22.8766C16.0571 22.1466 16.6703 21.1305 16.8999 20.0002H20.3699C20.832 20 21.2878 19.893 21.7017 19.6876C22.1157 19.4823 22.4766 19.184 22.7564 18.8162C23.0361 18.4484 23.2271 18.0209 23.3144 17.5672C23.4018 17.1134 23.3831 16.6455 23.2599 16.2002H23.2589ZM11.9999 22.0002C11.3816 21.9976 10.7792 21.8041 10.2752 21.4461C9.77109 21.0881 9.38994 20.5831 9.18385 20.0002H14.8159C14.6098 20.5831 14.2286 21.0881 13.7246 21.4461C13.2205 21.8041 12.6181 21.9976 11.9999 22.0002ZM21.1649 18.1052C21.0716 18.2289 20.9506 18.329 20.8117 18.3976C20.6728 18.4662 20.5198 18.5013 20.3649 18.5002H3.49285C3.34312 18.5001 3.19529 18.4665 3.0603 18.4017C2.92531 18.3369 2.80659 18.2426 2.71291 18.1258C2.61923 18.009 2.55297 17.8726 2.51904 17.7268C2.48511 17.5809 2.48436 17.4293 2.51685 17.2832L4.52785 8.23317C4.88221 6.63938 5.75916 5.20978 7.01931 4.17162C8.27946 3.13347 9.85048 2.54634 11.4826 2.50359C13.1148 2.46083 14.7144 2.96489 16.0272 3.93564C17.3399 4.90639 18.2905 6.28812 18.7279 7.86117L21.3279 17.2322C21.3703 17.3804 21.3777 17.5364 21.3494 17.6879C21.3211 17.8394 21.2579 17.9823 21.1649 18.1052Z"
          fill="#CACCCF"
        />
      </g>
      <defs>
        <clipPath id="clip0_658_4389">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </button>
</template>
<style scoped lang="scss">
.bell-button {
  position: fixed;
  top: 265px;
  right: 10px;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background-color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 13.6px 0px #0000001a;
}
</style>
